import { useMoveTo } from "@/utils/hooks/useMoveTo";
import React from "react";
import Button from "@/ui/Button/Button";
import { MinusIcon, NavArrowIcon, PlusIcon } from "@/assets/icons";
import { useZoom } from "@/utils/hooks/useZoom";
import { useLocationStore } from "@/store/userPosition";
import cls from "./styles.module.scss";

export default function MapController() {
  const moveTo = useMoveTo();

  const { zoomIn, zoomOut } = useZoom();

  const { requestLocationOnce } = useLocationStore();

  const handleGoToMe = async () => {
    const loc = await requestLocationOnce(true);
    if (!loc) return;
    moveTo(loc.longitude, loc.latitude, {
      zoom: 12,
      animate: true,
      duration: 1500,
    });
  };

  return (
    <div className={cls.ctrlBtnsWrapper}>
      <Button
        className={cls.ctrlBtn}
        onClick={() => zoomIn({ step: 1 })}
        variant="iconOnly"
        icon={<PlusIcon />}
      />
      <Button
        className={cls.ctrlBtn}
        onClick={() => zoomOut({ step: 1 })}
        variant="iconOnly"
        icon={<MinusIcon />}
      />
      <Button
        className={cls.ctrlBtn}
        onClick={handleGoToMe}
        variant="iconOnly"
        icon={<NavArrowIcon />}
      />
    </div>
  );
}
